<template>
  <el-tabs
    v-model="chartTabsValue"
    type="card"
    editable
    @edit="handleTabsEdit"
    @tab-click="changeTab"
    tab-position="bottom"
    class="r-tabs"
  >
    <el-tab-pane
      v-for="tabItem in chartTabs"
      :key="tabItem.name"
      :name="tabItem.name"
    >
      <r-text slot="label" class="nav-item" type="caption">
        {{ tabItem.title }}
      </r-text>
      <div v-if="layouts[tabItem.id] && layouts[tabItem.id].length">
        <grid-layout
          :layout="layouts[tabItem.id]"
          :col-num="12"
          :row-height="10"
          :max-rows="maxGridRows"
          :is-draggable="true"
          :is-resizable="true"
          :vertical-compact="true"
          :margin="[10, 10]"
          :use-css-transforms="true"
        >
          <grid-item
            v-for="item in layouts[tabItem.id]"
            :key="item.i"
            :x="item.x"
            :y="item.y"
            :w="item.w"
            :h="item.h"
            :i="item.i"
            :minW="5"
            :minH="18"
            :dragIgnoreFrom="
              '.vue-grid-item__content, .vue-grid-item__header-buttons'
            "
            @resized="resizedEvent"
            @moved="movedEvent"
          >
            <chart-item :item="item" />
          </grid-item>
        </grid-layout>
      </div>
      <div v-else class="charts-content__nochart-block">
        <r-icon name="pie" :size="64" />
        <r-title type="title-2">
          {{ $t("no-chart:title-1") }}
        </r-title>
        <r-title type="title-2">
          {{ $t("no-chart:title-2") }}
        </r-title>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import VueGridLayout from "vue-grid-layout";
import cloneDeep from "lodash.clonedeep";
import chartItem from "./chart-item/chart-item";

export default {
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    chartItem
  },
  data() {
    return {
      openedCharts: this.$store.state.charts.openedCharts,
      isLoading: false,
      layouts: {},
      maxGridRows: 40,

      chartTabsValue: "",
      chartTabs: [],
      tabIndex: 0
    };
  },
  watch: {
    "$store.state.charts.openedCharts": {
      handler: function() {
        this.openedCharts = this.$store.state.charts.openedCharts;
        this.layouts = this.$store.state.charts.chartsLayouts;
      },
      deep: true,
      immediate: true
    },
    "$store.state.charts.activeChart": {
      handler: function(value) {
        const activeTab = this.$store.state.charts.activeTab.tab;
        if (this.layouts[activeTab]) {
          this.layouts[activeTab].forEach(item => {
            item.i === Object.keys(value)[0]
              ? (item.active = true)
              : (item.active = false);
          });
        }
      },
      deep: true,
      immediate: true
    },
    "$store.state.charts.activeTab": {
      handler: function(value) {
        if (!value) {
          return;
        }
        this.openChartTabs();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async handleTabsEdit(targetName, action) {
      if (action === "add") {
        let newTabName = ++this.tabIndex + "";
        this.chartTabs.push({
          title: `Страница ${newTabName}`,
          name: newTabName,
          id: parseInt(newTabName)
        });
        this.chartTabsValue = newTabName;
        this.$store.commit("ADD_CHART_TAB", parseInt(newTabName));
        await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
      }
      if (action === "remove") {
        if (this.$store.state.charts.chartsLayouts[targetName].length) {
          const warningText = `${this.$t("modal.warning_text::closeTab")}`;
          const warningTitle = `${this.$t("modal.warning_title")}`;
          const confirmButtonText = `${this.$t("modal.confirm_button")}`;
          const cancelButtonText = `${this.$t("modal.cancel_button")}`;
          this.$confirm(warningText, warningTitle, {
            customClass: "r-message-box",
            type: "warning",
            confirmButtonText,
            cancelButtonText
          })
            .then(() => {
              this.closeTab(targetName);
            })
            .catch(() => {});
        } else {
          this.closeTab(targetName);
        }
      }
    },
    async closeTab(targetName) {
      let tabs = this.chartTabs;
      let activeName = this.chartTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.$store.state.charts.chartsLayouts[targetName].forEach(e => {
        this.$store.commit("CLOSE_CHART", { id: e.i, tab: targetName });
      });
      this.$store.commit("REMOVE_CHART_TAB", {
        i: parseInt(targetName),
        active: activeName
      });
      await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
      this.chartTabsValue = this.$store.state.charts.activeTab.tab;
      this.chartTabs = tabs.filter(tab => tab.name !== targetName);
    },
    changeTab(value) {
      this.$store.commit("CHANGE_ACTIVE_TAB", parseInt(value.name));
    },
    openChartTabs() {
      const chartsLayout = this.$store.state.charts.chartsLayouts;
      if (Object.keys(chartsLayout).length) {
        const chartTabs = [];
        let tabsIndex = [];

        for (let key in chartsLayout) {
          chartTabs.push({
            title: `Страница ${key}`,
            name: `${key}`,
            id: parseInt(key)
          });
          tabsIndex.push(parseInt(key));
        }
        this.chartTabsValue = `${this.$store.state.charts.activeTab.tab}`;
        this.chartTabs = chartTabs;
        this.tabIndex = Math.max(...tabsIndex);
      }
    },
    async movedEvent(i, newX, newY) {
      const config = {
        chartId: i,
        event: "moved",
        x: newX,
        y: newY,
        tab: this.chartTabsValue
      };
      this.$store.commit("CHANGE_CHART_LAYOUT", config);
      await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
    },
    async resizedEvent(i, newH, newW) {
      const config = {
        chartId: i,
        event: "resized",
        h: newH,
        w: newW,
        tab: this.chartTabsValue
      };
      this.$store.commit("CHANGE_CHART_LAYOUT", config);
      await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
    }
  },
  created() {
    const chartsLayout = this.$store.state.charts.chartsLayouts;

    if (!Object.keys(chartsLayout).length) {
      this.chartTabsValue = "1";
      this.chartTabs = [
        {
          title: "Страница 1",
          name: "1",
          id: 1
        }
      ];
      this.tabIndex = 1;
      this.$store.commit("ADD_CHART_TAB", this.tabIndex);
    } else {
      const firstTab = Object.keys(chartsLayout)[0];
      this.changeTab({ name: firstTab });
      this.openChartTabs();
    }
    this.openedCharts = this.$store.state.charts.openedCharts;
    this.layouts = cloneDeep(this.$store.state.charts.chartsLayouts);

    const clientHeight = document.documentElement.clientHeight - 120;
    this.maxGridRows = Math.floor(clientHeight / 20);
  }
};
</script>

<style lang="scss">
.charts {
  &-content {
    .r-tabs {
      .el-tabs {
        &__header {
          position: absolute;
          display: flex;
          width: 100%;
          height: 38px;
          bottom: 0;
          left: 0;
          border: 0;
          border-radius: 0 !important;
          box-sizing: border-box;
          background-color: var(--bg_panel_primary) !important;
        }
        &__nav-scroll {
          height: 100%;
        }
        &__new-tab {
          display: flex;
          align-items: center;
          justify-content: center;
          width: auto;
          font-size: 24px;
          line-height: 38px;
          overflow: hidden;
          margin: 0;
          height: 100%;
          border: none;
          border-radius: 0 !important;
          order: 1;
          outline: none;
          color: var(--text_secondary) !important;
          .el-icon-plus {
            padding: 6px;
            border-radius: var(--border-radius);
            border: 1px solid;
            border-color: var(--dividers_low_contrast) !important;
          }
          &:hover {
            .el-icon-plus {
              background-color: var(--accent_selected) !important;
            }
          }
        }
        &__nav {
          height: 100%;
          border: none !important;
          border-radius: 0 !important;
          display: flex;
        }
        &__item {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100% !important;
          width: 100px !important;
          overflow: hidden;
          border: none !important;
          padding: 5px 10px 5px 5px !important;
          box-sizing: border-box;
          .nav-item {
            color: var(--text_secondary) !important;
          }
          &:hover,
          &.is-active {
            background-color: var(--accent_selected) !important;
            .nav-item {
              color: var(--text_primary) !important;
            }
            .el-icon-close {
              right: 5px !important;
              color: var(--text_secondary) !important;
            }
          }
          .el-icon-close {
            position: absolute !important;
            background: none !important;
            font-size: 14px !important;
            top: 50% !important;
            transform: translateY(-50%);
            right: 0 !important;
          }
        }
      }
    }
    &__nochart-block {
      text-align: center;
      margin-top: 15vh;
    }
  }
}
.charts-type-switcher-popover {
  padding: 0 !important;
  &-reference {
    padding: 6px;
    border-radius: var(--border-radius);
  }
}
</style>

<i18n>
{
  "ru": {
    "no-chart:title-1": "Нет ни одного графика.",
    "no-chart:title-2": "Добавьте их в панели слева",
    "modal.confirm_button": "Да",
    "modal.cancel_button": "Нет",
    "modal.warning_title": "Предупреждение",
    "modal.warning_text::closeTab": "Страница будет закрыта вместе со всеми графиками. Продолжить?",
    "chart-change": "Изменить тип графика"
  },
  "en": {
    "no-chart:title-1": "There is not a single chart.",
    "no-chart:title-2": "Add one at the left panel",
    "modal.confirm_button": "Yes",
    "modal.cancel_button": "No",
    "modal.warning_title": "Warning",
    "modal.warning_text::closeTab": "Page will be closed with all charts. Continue?",
    "chart-change": "Change chart type"
  }
}
</i18n>
